import React from "react";
import { view } from "@risingstack/react-easy-state";
import { alertState, state } from "./kinesis-webrtc";
import { IoClose } from "react-icons/io5";
import {
  IoEyeOffOutline,
  IoPeopleOutline,
  IoChatboxOutline,
  IoWarningOutline,
} from "react-icons/io5";
import "./StudentAlertPopup.css";

const StudentAlertPopup = view(({ studentId, onClose }) => {
  // Filter alerts for this student and sort by timestamp in descending order
  const studentAlerts = state.behaviorAlerts
    .filter((alert) => alert.viewerId === studentId)
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

  // Group alerts by type
  const groupedAlerts = studentAlerts.reduce((acc, alert) => {
    const key = alert.type;
    if (!acc[key]) {
      acc[key] = {
        type: alert.type,
        count: 1,
        latestTimestamp: alert.timestamp,
        latestMessage: alert.message,
        alerts: [alert],
      };
    } else {
      acc[key].count++;
      if (new Date(alert.timestamp) > new Date(acc[key].latestTimestamp)) {
        acc[key].latestTimestamp = alert.timestamp;
        acc[key].latestMessage = alert.message;
      }
      acc[key].alerts.push(alert);
    }
    return acc;
  }, {});

  const handleClose = () => {
    alertState.openPopups[studentId] = false;
    onClose();
  };

  const getAlertIcon = (type) => {
    const iconProps = { size: 18 };
    const typeLC = type.toLowerCase();

    if (typeLC.includes("looking")) {
      return <IoEyeOffOutline {...iconProps} />;
    } else if (typeLC.includes("speaking")) {
      return <IoChatboxOutline {...iconProps} />;
    } else if (typeLC.includes("multiple")) {
      return <IoPeopleOutline {...iconProps} />;
    }
    return <IoWarningOutline {...iconProps} />;
  };

  return (
    <div className="alert-popup-container">
      <div className="alert-popup">
        <div className="alert-popup-header">
          <h3>Alerts for Student {studentId.slice(-4)}</h3>
          <button className="close-button" onClick={handleClose}>
            <IoClose size={20} />
          </button>
        </div>

        <div className="alert-popup-content">
          {studentAlerts.length === 0 ? (
            <div className="no-alerts">No alerts at this time</div>
          ) : (
            Object.values(groupedAlerts).map((group) => (
              <div
                key={`${group.type}-${group.latestTimestamp}`}
                className={`alert-item ${group.type
                  .toLowerCase()
                  .replace(" ", "-")}`}
              >
                <div className="alert-header">
                  <div className="alert-title-group">
                    <span className="alert-type-icon">
                      {getAlertIcon(group.type)}
                    </span>
                    <span className="alert-title">
                      {group.type}
                      {group.count > 1 && (
                        <span className="alert-count-badge">
                          ×{group.count}
                        </span>
                      )}
                    </span>
                  </div>
                  <span className="alert-time">
                    {new Date(group.latestTimestamp).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>
                <div className="alert-content">
                  <span className="alert-message">{group.latestMessage}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
});

export default StudentAlertPopup;
